import styled from 'styled-components';

import device from 'components/mediaQueries';

const ModalOverflow = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000000;
  opacity: 0.3;
`;

const ModalContent = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  top: 50%;
  left: 50%;
  opacity: 1;
  z-index: 100050;
  font-size: 15px;
  overflow: auto;
  background-color: #fff;
  background-clip: padding-box;
  transform: translate(-50%, -50%);
  font-family: 'Avenir Light', 'Arial', sans-serif;

  ${device.desktop`
    width: 50%;
    height: 200px;
    border-radius: 2px;
  `}

  ${device.mobile`
    min-width: 300px;
    height: 200px;
    width: 90%;
  `}
`;

export { ModalOverflow, ModalContent };
